module.exports = __webpack_public_path__ + "img/lowerabs-ectomorph-male.c32d407a.svg";